import { useQueryClient } from '@tanstack/react-query';

import type { QueryKey } from '@tanstack/react-query';

export const useOptimisticUpdate = <TData>(queryKey: QueryKey) => {
  const queryClient = useQueryClient();

  return async (patch: (previous: TData) => TData) => {
    await queryClient.cancelQueries({ queryKey });

    const previous = queryClient.getQueryData<TData>(queryKey);
    if (!previous) {
      return () => {};
    }

    queryClient.setQueryData(queryKey, patch(previous));

    return () => queryClient.setQueryData(queryKey, previous);
  };
};
